import { render, staticRenderFns } from "./PlaceLocalMenu.vue?vue&type=template&id=4315d47e&"
import script from "./PlaceLocalMenu.vue?vue&type=script&lang=js&"
export * from "./PlaceLocalMenu.vue?vue&type=script&lang=js&"
import style0 from "./PlaceLocalMenu.vue?vue&type=style&index=0&id=4315d47e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports